export const modal = {
  modifyTitle: "تعديل الحجز",
  createTitle: "إنشاء حجز",
  modifyAction: "تعديل الحجز",
  createAction: "إنشاء حجز",
  processing: "جارٍ معالجة الحجز...",

  selectRoomType: "اختر نوع الغرفة",
  selectAccommodation: "اختر مكان إقامة",

  quantity: "الكمية",
  arrival: "الوصول",
  departure: "المغادرة",
  guestName: "اسم النزيل",
  email: "البريد الإلكتروني",
  phone: "الهاتف",
  guestsNumber: "عدد النزلاء",
  price: "السعر",
  cancel: "إلغاء",

  noTemplateSummary: "لا يوجد قالب نشط",
  noTemplateDetail: "لا يوجد قالب متاح",

  limitReachedSummary: "تم بلوغ الحد",
  limitPromotionDetail: "لا يمكنك إضافة أكثر من عرض ترويجي واحد",
  limitTaxDetail: "لا يمكنك إضافة أكثر من ضريبة واحدة",

  validations: {
    fillRequired: "يُرجى إكمال جميع الحقول الإلزامية.",
    phoneMin: "يجب أن يتكوّن رقم الهاتف من 5 أرقام على الأقل.",
    selectDates: "يُرجى تحديد تاريخي الوصول والمغادرة.",
    guestsMin: "يجب أن يكون عدد النزلاء 1 على الأقل.",
    priceNegative: "لا يمكن أن يكون السعر سالبًا.",
  },
};

export default modal;
